import * as request from "../lib/lib";

const baseUrl = process.env.REACT_APP_BACKEND_URL + 'User';

export const getById = async (id) => {
    const result = await request.get(`${baseUrl}/Parent/${id}`);

    return result;
}

export const chpass = async (formData) => {
    console.log(formData);
    const result = await request.put(`${baseUrl}/ChangePass`, formData);

    return result;
}

export const fpass = async (formData) => {
    const result = await request.put(`${baseUrl}/ForgotPass`, formData);

    return result;
}

export const editParent = async (id, formData) => {
    const result = await request.put(`${baseUrl}/EditParent/${id}`, formData);

    return result;
}

export const resetPassword = async (id) => {
    const result = await request.put(`${baseUrl}/ResetPass/${id}`, {});

    return result;
}

export const getAllPredefinedUsers = async (formData) => {
    const result = await request.get(`${baseUrl}/GetAllPredefinedUsers`, formData);

    return result;
}

export const createUser = async (formData) => {
    const result = await request.post(`${baseUrl}/CreateUser`, formData);

    return result;
}

export const editUser = async (id, formData) => {
    const result = await request.put(`${baseUrl}/EditUser/${id}`, formData);

    return result;
}

export const activeDirectorsAccounts = async () => {
    const result = await request.put(`${baseUrl}/ActiveDirectorsAccounts`);

    return result;
}

export const deactiveDirectorsAccounts = async () => {
    const result = await request.put(`${baseUrl}/DeactiveDirectorsAccounts`);

    return result;
}